import { useCallback } from 'react';
import { healthCheckOrderConfirmUrl } from '@app/definition/API';
import apiClient from '@root/src/app/network/apiClient';

const usePreviousStageOrder = (): {
  previousStageOrder: (id: number) => Promise<void>;
} => {
  const previousStageOrder = useCallback(async (id: number): Promise<void> => {
    // const url = .replace('%id%', String(id));
    const mockUrl = healthCheckOrderConfirmUrl.replace('%id%', String(id));

    await apiClient.patch(mockUrl);
  }, []);

  return {
    previousStageOrder,
  };
};

export default usePreviousStageOrder;
